import { Component } from '@angular/core';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';

@Component({
    standalone: false,
    selector: 'app-login-or-create-account-dialog',
    templateUrl: './login-or-create-account-dialog.component.html'
})
export class LoginOrCreateAccountDialogComponent extends BasicDialogComponent {

    constructor() {
        super();
    }
}
